webpackJsonp([114276838955818,60335399758886],{

/***/ 108:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(216);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(108);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(100);
	var isArguments = __webpack_require__(99);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(131);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(98);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(127);
	
	var _HelmetConstants = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(102));
	var shallowEqual = _interopDefault(__webpack_require__(132));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"constrain":"src-components-Constrain----constrain-module---constrain---1plXW"};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constrainModule = __webpack_require__(103);
	
	var _constrainModule2 = _interopRequireDefault(_constrainModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Constrain = function Constrain(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: _constrainModule2.default.constrain },
	        children
	    );
	};
	
	exports.default = Constrain;
	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-components-Footer----footer-module---footer---31Fwu","contactInfo":"src-components-Footer----footer-module---contactInfo---293RR"};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(306);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	var _SocialIcons = __webpack_require__(213);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	    return _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.footer },
	        _react2.default.createElement(_SocialIcons2.default, null),
	        _react2.default.createElement(
	            'ul',
	            { className: _footerModule2.default.contactInfo },
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'tel:+447490117166' },
	                    '+44 (0) 7490 117166'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:hello@artiseq.com' },
	                    'hello@artiseq.com'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Copyright \xA9 2018. All rights reserved.'
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Header----header-module---header---1mgxU"};

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(164);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _artiseqLogo = __webpack_require__(445);
	
	var _artiseqLogo2 = _interopRequireDefault(_artiseqLogo);
	
	var _headerModule = __webpack_require__(307);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	    return _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.header },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	                to: '/'
	            },
	            _react2.default.createElement('img', { src: _artiseqLogo2.default, alt: 'Logo' })
	        )
	    );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _socialIconsModule = __webpack_require__(309);
	
	var _socialIconsModule2 = _interopRequireDefault(_socialIconsModule);
	
	var _Twitter = __webpack_require__(215);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _LinkedIn = __webpack_require__(214);
	
	var _LinkedIn2 = _interopRequireDefault(_LinkedIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialIcons = function SocialIcons() {
	    return _react2.default.createElement(
	        'ul',
	        { className: _socialIconsModule2.default.socialIcons },
	        _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	                'a',
	                { href: 'https://www.linkedin.com/company/artiseq/' },
	                _react2.default.createElement(_LinkedIn2.default, null)
	            )
	        ),
	        _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/artiseq' },
	                _react2.default.createElement(_Twitter2.default, null)
	            )
	        )
	    );
	};
	
	exports.default = SocialIcons;
	module.exports = exports['default'];

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"socialIcons":"src-components-SocialIcons----social-icons-module---socialIcons---3FO7s"};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkedInIcon = function LinkedInIcon(_ref) {
	    var _ref$width = _ref.width,
	        width = _ref$width === undefined ? 24 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 24 : _ref$height;
	    return _react2.default.createElement(
	        "svg",
	        { width: width, height: height, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
	        _react2.default.createElement(
	            "g",
	            { id: "Marketing", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "Mobile", transform: "translate(-126.000000, -2344.000000)", fill: "#FFFFFF" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Footer", transform: "translate(-26.000000, 2287.000000)" },
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Group-2", transform: "translate(152.000000, 57.000000)" },
	                        _react2.default.createElement("path", { d: "M0.50390625,7.9921875 L5.49609375,7.9921875 L5.49609375,23.4960938 L0.50390625,23.4960938 L0.50390625,7.9921875 Z M8.49609375,23.4960938 L8.49609375,11.4960938 L8.4140625,7.9921875 L13.3359375,7.9921875 L13.5,10.1367188 C14.0312527,9.33202723 14.6757775,8.69140863 15.4335938,8.21484375 C16.19141,7.73827887 17.0468702,7.5 18,7.5 C19.796884,7.5 21.2460882,8.11522822 22.3476562,9.34570312 C23.4492243,10.576178 24,12.2929577 24,14.4960938 L24,23.4960938 L18.9960938,23.4960938 L18.9960938,15 C18.9960938,13.8124941 18.7441431,12.9316435 18.2402344,12.3574219 C17.7363256,11.7832003 17.0820353,11.4960938 16.2773438,11.4960938 C15.4804648,11.4960938 14.818362,11.7558568 14.2910156,12.2753906 C13.7636692,12.7949245 13.5,13.5351514 13.5,14.4960938 L13.5,23.4960938 L8.49609375,23.4960938 Z M2.9765625,5.49609375 L2.94140625,5.49609375 C2.07421441,5.49609375 1.36719023,5.23242451 0.8203125,4.70507812 C0.273434766,4.17773174 0,3.52344141 0,2.7421875 C0,1.95312105 0.279294082,1.29883072 0.837890625,0.779296875 C1.39648717,0.259763027 2.12499551,0 3.0234375,0 C3.90625441,0 4.61913791,0.259763027 5.16210938,0.779296875 C5.70508084,1.29883072 5.98437492,1.95312105 6,2.7421875 C6,3.53125395 5.72265902,4.18749738 5.16796875,4.7109375 C4.61327848,5.23437762 3.88281703,5.49609375 2.9765625,5.49609375 Z", id: "linkedin" })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = LinkedInIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterIcon = function TwitterIcon(_ref) {
	    var _ref$width = _ref.width,
	        width = _ref$width === undefined ? 24 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 20 : _ref$height;
	    return _react2.default.createElement(
	        "svg",
	        { width: width, height: height, viewBox: "0 0 24 20", version: "1.1", xmlnsXlink: "http://www.w3.org/1999/xlink" },
	        _react2.default.createElement(
	            "g",
	            { id: "Marketing", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "Mobile", transform: "translate(-175.000000, -2348.000000)", fill: "#FFFFFF" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Footer", transform: "translate(-26.000000, 2287.000000)" },
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Group-2", transform: "translate(152.000000, 57.000000)" },
	                        _react2.default.createElement("path", { d: "M73,6.296875 C72.3437467,7.28906746 71.5273486,8.14062145 70.5507812,8.8515625 L70.5507812,9.49609375 C70.5507812,10.5898492 70.4121108,11.6894476 70.1347656,12.7949219 C69.8574205,13.9003962 69.458987,14.9746042 68.9394531,16.0175781 C68.4199193,17.0605521 67.7539103,18.0351517 66.9414062,18.9414062 C66.1289022,19.8476608 65.218755,20.6386685 64.2109375,21.3144531 C63.20312,21.9902378 62.0410222,22.5234355 60.7246094,22.9140625 C59.4081965,23.3046895 58.0195386,23.5 56.5585938,23.5 C53.5976414,23.5 51.0781354,22.8320379 49,21.4960938 C49.3593768,21.5507815 49.7499979,21.578125 50.171875,21.578125 C51.2656305,21.578125 52.3359323,21.3671896 53.3828125,20.9453125 C54.4296927,20.5234354 55.3945268,19.9570348 56.2773438,19.2460938 C55.222651,19.2382812 54.2714886,18.9121126 53.4238281,18.2675781 C52.5761676,17.6230437 52.0000015,16.8085987 51.6953125,15.8242188 C52.0234391,15.8867191 52.3281236,15.9179688 52.609375,15.9179688 C53.0625023,15.9179688 53.4999979,15.8593756 53.921875,15.7421875 C52.7890568,15.5156239 51.84766,14.9511764 51.0976562,14.0488281 C50.3476525,13.1464799 49.9726562,12.1015684 49.9726562,10.9140625 L49.9726562,10.8554688 C50.6757848,11.2382832 51.4179648,11.4414061 52.1992188,11.4648438 C51.5195279,11.0117165 50.9824238,10.4257848 50.5878906,9.70703125 C50.1933574,8.98827766 49.9960938,8.21484789 49.9960938,7.38671875 C49.9960938,6.58202723 50.2187478,5.7851602 50.6640625,4.99609375 C51.8984437,6.49610125 53.3906162,7.68554248 55.140625,8.56445312 C56.8906338,9.44336377 58.7773336,9.93749945 60.8007812,10.046875 C60.7304684,9.74218598 60.6953125,9.36328352 60.6953125,8.91015625 C60.6953125,7.55077445 61.1738233,6.39258291 62.1308594,5.43554688 C63.0878954,4.47851084 64.246087,4 65.6054688,4 C67.0039132,4 68.2109324,4.51561984 69.2265625,5.546875 C70.3437556,5.32031137 71.3789015,4.92187785 72.3320312,4.3515625 C71.9570294,5.53906844 71.2343804,6.44921559 70.1640625,7.08203125 C71.1406299,6.9726557 72.0859329,6.71093957 73,6.296875 Z", id: "twitter" })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = TwitterIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTA2cHgiIGhlaWdodD0iMzhweCIgdmlld0JveD0iMCAwIDEwNiAzOCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkuMSAoNTExNDcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkdyb3VwIDM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iTWFya2V0aW5nIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iVGFibGV0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzMwLjAwMDAwMCwgLTMwLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzMwLjAwMDAwMCwgMzAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjAuOTIsMjkgTDE5LjcyLDI5IEwxNi4yLDE4LjkyIEw1LjEyLDE4LjkyIEwxLjY0LDI5IEwwLjQsMjkgTDEwLjI4LDAuOTYgTDExLjA0LDAuOTYgTDIwLjkyLDI5IFogTTEwLjY0LDIuNDQgTDguNzYsOC40NCBMNS41MiwxNy44IEwxNS44LDE3LjggTDEyLjU2LDguNDQgTDEwLjY4LDIuNDQgTDEwLjY0LDIuNDQgWiBNMzIuODIyMjIyMSwxMCBDMjkuNjYyMjIyMSw5LjggMjcuMzAyMjIyMSwxMS42OCAyNi4xODIyMjIxLDE0LjYgTDI2LjE4MjIyMjEsMjkgTDI1LjAyMjIyMjEsMjkgTDI1LjAyMjIyMjEsMTQuOTYgQzI1LjAyMjIyMjEsMTMuMDggMjQuOTQyMjIyMSwxMS4wNCAyNC45MDIyMjIxLDkuMDggTDI1Ljk0MjIyMjEsOS4wNCBMMjYuMTAyMjIyMSwxMi44NCBMMjYuMTQyMjIyMSwxMi44NCBDMjcuMzQyMjIyMSwxMC42IDI5LjY2MjIyMjEsOC42IDMyLjgyMjIyMjEsOC43MiBMMzIuODIyMjIyMSwxMCBaIE0zNy40ODQ0NDQzLDEwLjE2IEwzNC4yMDQ0NDQzLDEwLjE2IEwzNC4yODQ0NDQzLDkuMjQgTDM3LjQ0NDQ0NDMsOS4wOCBMMzcuNjg0NDQ0Myw0LjY0IEwzOC42ODQ0NDQzLDQuMjggTDM4LjY4NDQ0NDMsOS4wOCBMNDQuMzI0NDQ0Myw5LjA4IEw0NC4yNDQ0NDQzLDEwLjE2IEwzOC42ODQ0NDQzLDEwLjE2IEwzOC42ODQ0NDQzLDIzLjkyIEMzOC42ODQ0NDQzLDI3Ljg4IDQwLjE2NDQ0NDMsMjguMjQgNDEuNTY0NDQ0MywyOC4yNCBDNDIuNjg0NDQ0MywyOC4yNCA0My42ODQ0NDQzLDI3LjkyIDQ0LjQ0NDQ0NDMsMjcuNjggTDQ0LjQ4NDQ0NDMsMjguODQgQzQzLjYwNDQ0NDMsMjkuMTYgNDIuNTY0NDQ0MywyOS40IDQxLjU2NDQ0NDMsMjkuNCBDMzguNTI0NDQ0MywyOS40IDM3LjQ4NDQ0NDMsMjcuNDggMzcuNDg0NDQ0MywyNC4xNiBMMzcuNDg0NDQ0MywxMC4xNiBaIE00OC40MjY2NjY0LDMgQzQ4LjQyNjY2NjQsMi40IDQ4LjgyNjY2NjQsMS45NiA0OS40NjY2NjY0LDEuOTYgQzUwLjA2NjY2NjQsMS45NiA1MC41MDY2NjY0LDIuNCA1MC41MDY2NjY0LDMgQzUwLjUwNjY2NjQsMy42NCA1MC4wNjY2NjY0LDQuMDQgNDkuNDY2NjY2NCw0LjA0IEM0OC44MjY2NjY0LDQuMDQgNDguNDI2NjY2NCwzLjY0IDQ4LjQyNjY2NjQsMyBaIE00OC44NjY2NjY0LDkuMDggTDUwLjAyNjY2NjQsOC45NiBMNTAuMDI2NjY2NCwyOSBMNDguODY2NjY2NCwyOSBMNDguODY2NjY2NCw5LjA4IFogTTYwLjEyODg4ODYsMjguMjggQzYzLjIwODg4ODYsMjguMjggNjUuMzI4ODg4NiwyNi42IDY1LjMyODg4ODYsMjMuOTIgQzY1LjMyODg4ODYsMTguMTYgNTUuNDg4ODg4NiwxOS41NiA1NS40ODg4ODg2LDEzLjU2IEM1NS40ODg4ODg2LDEwLjc2IDU3LjU2ODg4ODYsOC42OCA2MS4yMDg4ODg2LDguNjggQzYyLjk2ODg4ODYsOC42OCA2NC44NDg4ODg2LDkuMTYgNjYuMDA4ODg4Niw5LjggTDY1Ljg4ODg4ODYsMTEuMTIgQzY0Ljg0ODg4ODYsMTAuNTIgNjIuODg4ODg4Niw5LjggNjEuMTI4ODg4Niw5LjggQzU4LjIwODg4ODYsOS44IDU2LjY0ODg4ODYsMTEuNDggNTYuNjQ4ODg4NiwxMy41NiBDNTYuNjQ4ODg4NiwxOC42NCA2Ni40ODg4ODg2LDE3LjI4IDY2LjQ4ODg4ODYsMjMuODggQzY2LjQ4ODg4ODYsMjcuMTYgNjQuMDQ4ODg4NiwyOS40IDYwLjEyODg4ODYsMjkuNCBDNTguMzY4ODg4NiwyOS40IDU2LjQ0ODg4ODYsMjguOTYgNTUuMDQ4ODg4NiwyOC4yIEw1NS40NDg4ODg2LDI3LjA0IEM1Ni43Njg4ODg2LDI3LjY0IDU4LjI0ODg4ODYsMjguMjggNjAuMTI4ODg4NiwyOC4yOCBaIE03OS4wNzExMTA3LDI5LjQgQzcyLjgzMTExMDcsMjkuNCA3MC4wMzExMTA3LDI1LjIgNzAuMDMxMTEwNywxOS4yNCBDNzAuMDMxMTEwNywxMi40OCA3My41OTExMTA3LDguNjggNzguNTUxMTEwNyw4LjY4IEM4NC4yMzExMTA3LDguNjggODYuMjcxMTEwNywxMy42IDg1LjU1MTExMDcsMTguNiBMNzEuMjMxMTEwNywxOC42IEM3MS4yMzExMTA3LDI0Ljc2IDczLjYzMTExMDcsMjguMjggNzkuMjMxMTEwNywyOC4yOCBDODEuNTUxMTEwNywyOC4yOCA4My41OTExMTA3LDI3LjYgODQuNzkxMTEwNywyNy4wNCBMODQuODcxMTEwNywyOC4yNCBDODMuOTkxMTEwNywyOC43MiA4MS42NzExMTA3LDI5LjQgNzkuMDcxMTEwNywyOS40IFogTTg0LjQzMTExMDcsMTcuNDggQzg0Ljg3MTExMDcsMTMuNiA4Mi45MTExMTA3LDkuOCA3OC41NTExMTA3LDkuOCBDNzMuODMxMTEwNyw5LjggNzEuNzExMTEwNywxMy42NCA3MS4zMTExMTA3LDE3LjQ4IEw4NC40MzExMTA3LDE3LjQ4IFogTTk2LjczMzMzMjksMjkuNCBDOTEuNjEzMzMyOSwyOS40IDg4Ljk3MzMzMjksMjUuMjQgODguOTczMzMyOSwxOS4xNiBDODguOTczMzMyOSwxMi4yOCA5My4zNzMzMzI5LDguNjggOTcuOTMzMzMyOSw4LjY4IEMxMDAuODkzMzMzLDguNjggMTAzLjI5MzMzMyw5LjcyIDEwNS4xNzMzMzMsMTEuMDQgTDEwNS4xNzMzMzMsMzcuOTYgTDEwNC4wMTMzMzMsMzcuOTYgTDEwNC4wMTMzMzMsMjUuNzIgTDEwMy45MzMzMzMsMjUuNzIgQzEwMi4zMzMzMzMsMjcuODggOTkuODEzMzMyOSwyOS40IDk2LjczMzMzMjksMjkuNCBaIE05Ni42MTMzMzI5LDI4LjMyIEM5OS42NTMzMzI5LDI4LjMyIDEwMi43MzMzMzMsMjYuNDQgMTA0LjAxMzMzMywyMy41NiBMMTA0LjAxMzMzMywxMS44IEMxMDMuMzczMzMzLDExLjE2IDEwMC44NTMzMzMsOS43NiA5Ny43MzMzMzI5LDkuNzYgQzkzLjQxMzMzMjksOS43NiA5MC4xNzMzMzI5LDEzLjggOTAuMTczMzMyOSwxOS4xMiBDOTAuMTczMzMyOSwyMy45MiA5MS45NzMzMzI5LDI4LjMyIDk2LjYxMzMzMjksMjguMzIgWiIgaWQ9IkFydGlzZXEiIGZpbGw9IiM1MEUzQzIiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMC45MiwyOSBMMTkuNzIsMjkgTDE2LjIsMTguOTIgTDUuMTIsMTguOTIgTDEuNjQsMjkgTDAuNCwyOSBMMTAuMjgsMC45NiBMMTEuMDQsMC45NiBMMjAuOTIsMjkgWiBNMTAuNjQsMi40NCBMOC43Niw4LjQ0IEw1LjUyLDE3LjggTDE1LjgsMTcuOCBMMTIuNTYsOC40NCBMMTAuNjgsMi40NCBMMTAuNjQsMi40NCBaIE0zMi44MjIyMjIxLDEwIEMyOS42NjIyMjIxLDkuOCAyNy4zMDIyMjIxLDExLjY4IDI2LjE4MjIyMjEsMTQuNiBMMjYuMTgyMjIyMSwyOSBMMjUuMDIyMjIyMSwyOSBMMjUuMDIyMjIyMSwxNC45NiBDMjUuMDIyMjIyMSwxMy4wOCAyNC45NDIyMjIxLDExLjA0IDI0LjkwMjIyMjEsOS4wOCBMMjUuOTQyMjIyMSw5LjA0IEwyNi4xMDIyMjIxLDEyLjg0IEwyNi4xNDIyMjIxLDEyLjg0IEMyNy4zNDIyMjIxLDEwLjYgMjkuNjYyMjIyMSw4LjYgMzIuODIyMjIyMSw4LjcyIEwzMi44MjIyMjIxLDEwIFogTTM3LjQ4NDQ0NDMsMTAuMTYgTDM0LjIwNDQ0NDMsMTAuMTYgTDM0LjI4NDQ0NDMsOS4yNCBMMzcuNDQ0NDQ0Myw5LjA4IEwzNy42ODQ0NDQzLDQuNjQgTDM4LjY4NDQ0NDMsNC4yOCBMMzguNjg0NDQ0Myw5LjA4IEw0NC4zMjQ0NDQzLDkuMDggTDQ0LjI0NDQ0NDMsMTAuMTYgTDM4LjY4NDQ0NDMsMTAuMTYgTDM4LjY4NDQ0NDMsMjMuOTIgQzM4LjY4NDQ0NDMsMjcuODggNDAuMTY0NDQ0MywyOC4yNCA0MS41NjQ0NDQzLDI4LjI0IEM0Mi42ODQ0NDQzLDI4LjI0IDQzLjY4NDQ0NDMsMjcuOTIgNDQuNDQ0NDQ0MywyNy42OCBMNDQuNDg0NDQ0MywyOC44NCBDNDMuNjA0NDQ0MywyOS4xNiA0Mi41NjQ0NDQzLDI5LjQgNDEuNTY0NDQ0MywyOS40IEMzOC41MjQ0NDQzLDI5LjQgMzcuNDg0NDQ0MywyNy40OCAzNy40ODQ0NDQzLDI0LjE2IEwzNy40ODQ0NDQzLDEwLjE2IFogTTQ4LjQyNjY2NjQsMyBDNDguNDI2NjY2NCwyLjQgNDguODI2NjY2NCwxLjk2IDQ5LjQ2NjY2NjQsMS45NiBDNTAuMDY2NjY2NCwxLjk2IDUwLjUwNjY2NjQsMi40IDUwLjUwNjY2NjQsMyBDNTAuNTA2NjY2NCwzLjY0IDUwLjA2NjY2NjQsNC4wNCA0OS40NjY2NjY0LDQuMDQgQzQ4LjgyNjY2NjQsNC4wNCA0OC40MjY2NjY0LDMuNjQgNDguNDI2NjY2NCwzIFogTTQ4Ljg2NjY2NjQsOS4wOCBMNTAuMDI2NjY2NCw4Ljk2IEw1MC4wMjY2NjY0LDI5IEw0OC44NjY2NjY0LDI5IEw0OC44NjY2NjY0LDkuMDggWiBNNjAuMTI4ODg4NiwyOC4yOCBDNjMuMjA4ODg4NiwyOC4yOCA2NS4zMjg4ODg2LDI2LjYgNjUuMzI4ODg4NiwyMy45MiBDNjUuMzI4ODg4NiwxOC4xNiA1NS40ODg4ODg2LDE5LjU2IDU1LjQ4ODg4ODYsMTMuNTYgQzU1LjQ4ODg4ODYsMTAuNzYgNTcuNTY4ODg4Niw4LjY4IDYxLjIwODg4ODYsOC42OCBDNjIuOTY4ODg4Niw4LjY4IDY0Ljg0ODg4ODYsOS4xNiA2Ni4wMDg4ODg2LDkuOCBMNjUuODg4ODg4NiwxMS4xMiBDNjQuODQ4ODg4NiwxMC41MiA2Mi44ODg4ODg2LDkuOCA2MS4xMjg4ODg2LDkuOCBDNTguMjA4ODg4Niw5LjggNTYuNjQ4ODg4NiwxMS40OCA1Ni42NDg4ODg2LDEzLjU2IEM1Ni42NDg4ODg2LDE4LjY0IDY2LjQ4ODg4ODYsMTcuMjggNjYuNDg4ODg4NiwyMy44OCBDNjYuNDg4ODg4NiwyNy4xNiA2NC4wNDg4ODg2LDI5LjQgNjAuMTI4ODg4NiwyOS40IEM1OC4zNjg4ODg2LDI5LjQgNTYuNDQ4ODg4NiwyOC45NiA1NS4wNDg4ODg2LDI4LjIgTDU1LjQ0ODg4ODYsMjcuMDQgQzU2Ljc2ODg4ODYsMjcuNjQgNTguMjQ4ODg4NiwyOC4yOCA2MC4xMjg4ODg2LDI4LjI4IFogTTc5LjA3MTExMDcsMjkuNCBDNzIuODMxMTEwNywyOS40IDcwLjAzMTExMDcsMjUuMiA3MC4wMzExMTA3LDE5LjI0IEM3MC4wMzExMTA3LDEyLjQ4IDczLjU5MTExMDcsOC42OCA3OC41NTExMTA3LDguNjggQzg0LjIzMTExMDcsOC42OCA4Ni4yNzExMTA3LDEzLjYgODUuNTUxMTEwNywxOC42IEw3MS4yMzExMTA3LDE4LjYgQzcxLjIzMTExMDcsMjQuNzYgNzMuNjMxMTEwNywyOC4yOCA3OS4yMzExMTA3LDI4LjI4IEM4MS41NTExMTA3LDI4LjI4IDgzLjU5MTExMDcsMjcuNiA4NC43OTExMTA3LDI3LjA0IEw4NC44NzExMTA3LDI4LjI0IEM4My45OTExMTA3LDI4LjcyIDgxLjY3MTExMDcsMjkuNCA3OS4wNzExMTA3LDI5LjQgWiBNODQuNDMxMTEwNywxNy40OCBDODQuODcxMTEwNywxMy42IDgyLjkxMTExMDcsOS44IDc4LjU1MTExMDcsOS44IEM3My44MzExMTA3LDkuOCA3MS43MTExMTA3LDEzLjY0IDcxLjMxMTExMDcsMTcuNDggTDg0LjQzMTExMDcsMTcuNDggWiIgaWQ9IkFydGlzZXEiIGZpbGw9IiM0QTRBNEEiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/idea-in-hand.16d179db.jpg";

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(126);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(211);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(210);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Constrain = __webpack_require__(72);
	
	var _Constrain2 = _interopRequireDefault(_Constrain);
	
	__webpack_require__(311);
	
	var _ideaInHand = __webpack_require__(133);
	
	var _ideaInHand2 = _interopRequireDefault(_ideaInHand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://use.typekit.net/djl2pdv.css' })
	        ),
	        _react2.default.createElement(_Header2.default, null),
	        children(),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	
	TemplateWrapper.propTypes = {
	    children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9538a344ad728c1e4316.js